export default __webpack_public_path__ + "static/media/flashingarc1.e3dd8df3.png";